export default __webpack_public_path__ + "static/media/carrot.87ef44f2.jpg";